import { render, staticRenderFns } from "./HSCodeFormDialog.vue?vue&type=template&id=27b4f250&"
import script from "./HSCodeFormDialog.vue?vue&type=script&lang=ts&"
export * from "./HSCodeFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports